module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/107-kwait-a81ea64a46f0cf37acc9750d83d214cd.svg";